var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_390_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7124 8.37964L17.4133 0H15.8254L10.0071 7.27593L5.35992 0H0L7.02738 11.0025L0 19.7898H1.58799L7.73237 12.1062L12.6401 19.7898H18L10.7121 8.37964H10.7124ZM8.53747 11.0994L7.82546 10.0038L2.16017 1.28602H4.59922L9.17118 8.32157L9.8832 9.41716L15.8262 18.5623H13.3871L8.53747 11.0998V11.0994Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_390_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.487ef348578eed27de0308e938e2887d.svg";
export { ForwardRef as ReactComponent };